import {FETCH_USER, CLEAR_USER} from './constants';

export const fetchUser = () => ({
    type: FETCH_USER
});

export const clearUser = () => ({
    type: CLEAR_USER
});
